<!--
 * @Author: your name
 * @Date: 2022-04-14 11:22:28
 * @LastEditTime: 2022-04-18 16:24:16
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cacaclo_front_end\src\views\publish\listings\components\MTDetail.vue
-->
<template>
    <div class="main">
        <div class="top bg-white">
            <div class="back">
                <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
                {{ $t('Publish.Listings.Components.MTDetail.Listing') }}
            </div>
            <div class="font">
                {{ $t('Publish.Listings.Components.MTDetail.Tips1') }}
            </div>
            <div class="link">
                <i class="el-icon-monitor"></i>
                https://www.kakaclo.com
            </div>
        </div>
        <div class="f product_info bg-white">
            <el-image :src="productInfo.imageUrl" style="width: 1.6rem;height: 1.6rem;" class="image"></el-image>
            <div class="fontInfo">
            <p class="ellipsis title">{{ productInfo.title }}</p>
            <p class="gray">{{ $t('Publish.Listings.Components.MTDetail.ProductId') }}: {{ productInfo.productId }}</p>
            <p class="gray">{{ $t('Publish.Listings.Components.MTDetail.ProductCoat') }}: {{ productInfo.currency }} {{ productInfo.priceScope.split('～')[1] }}</p>
            <p class="gray">{{ $t('Publish.Listings.Components.MTDetail.Inventory') }}: {{ productInfo.inventoryQuantityScope.split('～')[1] }}</p>
            </div>
        </div>
        <div class="skus bg-white">
            <div class="title">SKU</div>
            <Divider class="title_divider"></Divider>
            <div class="info" v-for="item in productInfo.variants" :key="item.sku">
                <div class="font">
                    <p class="sku">{{ item.sku }}</p>
                    <p class="other">{{ $t('Publish.Listings.Components.MTDetail.ProductCost') }}: {{ productInfo.currency }} {{ item.price }}</p>
                    <p class="other">{{ $t('Publish.Listings.Components.MTDetail.Inventory') }}: {{ item.inventoryQuantity }}</p>
                </div>
                <Divider></Divider>
            </div>
        </div>
    </div>
</template>

<script>
import Divider from 'vant/lib/divider'
import 'vant/lib/divider/style'
export default {
  components: {
    Divider
  },
  data() {
    return {
      productId: ''
    }
  },
  created() {
    this.productId = this.$route.query.id
  },
  computed: {
    productInfo() {
      console.log(this.$store.state.published.MTProductDetail)
      return this.$store.state.published.MTProductDetail
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
    .top {
        font-size: .3rem;
        margin-bottom: .2rem;
        .back {
            color: #7B7B7B;
            padding: .2rem;
            font-size: .3rem;
        }
        .font {
            width: 100%;
            padding: .2rem .8rem;
            text-align: center;
            line-height: .4rem;
            color: #99C41C;
            // padding: ;
        }
        .link {
            width: 100%;
            text-align: center;
            padding: 0 0 .2rem;
            .el-icon-monitor {
                font-size: .4rem;
            }
        }
    }
    .product_info {
    width: 100%;
    padding: .2rem;
    margin-bottom: .2rem;
        .image {
        flex-shrink: 0;
        width: 1.6rem;
        height: 1.6rem;
        margin-right: .2rem;
        }
        .fontInfo {
            max-width: calc(100% - 2rem);
            .title {
                font-size: .3rem;
                line-height: .6rem;
            }
            .gray{
                color: #7B7B7B;
            }
        }
        .price {
            font-size: .4rem;
            font-weight: 600;
            display: flex;
            align-items: flex-end;
        }
    }
    .skus {
        .title {
            padding: .2rem .3rem;
        }
        .info {
            color: gray;
            padding: .4rem .3rem 0;
            .font {
                line-height: .5rem;
                .sku {
                    font-size: .35rem;
                }
                .other {
                    font-size: .3rem;
                }
            }
        }
        /deep/.title_divider {
            margin: 0;
        }
    }
}
/deep/.van-divider {
    margin-bottom: 0;
}
</style>
